import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import Utils from '../../../utils/Utils';
import Device from "../../../devices/device";
import logger from 'src/utils/logger/logger';

class queryUserSyncTask extends AbstractRequestTask {
    constructor(params = {}) {
        super();

        this.queryParams = params;
        this.body = {};
        this.correlatorId = "AFF521489FFF5563EE@000000@20220907144911";
        this.msisdn = '541111111111';
        this.providerId = 'AMCOOTT_GT';
        this.serviceName = 'queryUserSync';
    }

    getHeaders() {
        const headerParams = {
            'Content-Type': 'application/json',
            // 'Content-Type': 'application/x-www-form-urlencoded',
            'Session-Id': ''
        };

        return headerParams;
    }

    // getParams() {
    //         return Utils.encodeParams(this.body);
    // }

    getUrl() {
        const http = "https://";
        const url = Launcher.get("akamai_mfwk");

        // return `${http}${url}/usersSync/user/queryUserSync?${this.getQueryStringParams()}`;

        return `${url}/usersSync/user/queryUserSync?`;
    }

    getMethod() {
        return 'POST';
    }

    getParams() {
        let params = super.getParams();
        const extra_params = {};
        const { serial_id } = Device.getDevice().getConfig();

        extra_params.serial_id = serial_id;

        logger.debug("[queryUserSync params::]", params);
        logger.debug('[queryUserSync params serialid]:: ', serial_id);
        const queryUserSyncRequest = {
            'CUSTOMERID': '',
            'correlatorId': this.correlatorId,
            'country': params.region,
            'deviceId': serial_id,
            'msisdn': this.msisdn,
            'providerId': this.providerId,
            'serviceName': this.serviceName
        };

        delete params.HKS;
        delete params.api_version;
        delete params.format;

        logger.debug("[queryUserSyncRequest::]", queryUserSyncRequest, params);

        //* No se envian params
        params = Object.assign({}, queryUserSyncRequest);
        logger.debug("[queryUserSync params 01]:: ", params);

        return params;
    }

    getRetriesNumber(){
        return 0;
    }

    isValid(data) {
        logger.debug('[loginbyToken V1 isValid]:: ', data);
        if (data.errors || !data || data === 'errors') {
            return false;
        }

        return true;
    }

    // getEncType() {
    //     return "application/x-www-form-urlencoded";
    // }
}

export default queryUserSyncTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/QueryUserSyncTask.js